import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
//import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getEmploymentRel = iType => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYMENT_RELATIONSHIP,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Relacion_Laboral/' : '/api/app/Funcional_Relacion_Laboral/', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    dispatch({
      type: actions.GET_EMPLOYMENT_RELATIONSHIP,
      payload: {
        employmentRelationShip: resp.data.data,
        employmentRelationShipLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMPLOYMENT_RELATIONSHIP,
      payload: false
    });
  }
}